import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9d6809bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("table", { class: "company-profile" }, [
  /*#__PURE__*/_createElementVNode("tbody", null, [
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "社名"),
      /*#__PURE__*/_createElementVNode("td", null, "株式会社MedicalWEB ／ MedicalWEB Inc.")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "設立"),
      /*#__PURE__*/_createElementVNode("td", null, "2021年11月01日")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "所在地"),
      /*#__PURE__*/_createElementVNode("td", null, [
        /*#__PURE__*/_createTextVNode("〒220-0004"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("神奈川県横浜市西区北幸二丁目10番27号 東武立野ビル601")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "代表"),
      /*#__PURE__*/_createElementVNode("td", null, "代表取締役CEO 内田 祐吾")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "代表番号"),
      /*#__PURE__*/_createElementVNode("td", null, "045-577-9151")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "FAX番号"),
      /*#__PURE__*/_createElementVNode("td", null, "045-577-9152")
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "事業内容"),
      /*#__PURE__*/_createElementVNode("td", null, [
        /*#__PURE__*/_createTextVNode(" 美容医療・歯科クリニック・治療院に特化したWEBマーケティング事業"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("WEBサイト制作・システム開発・アプリケーション開発事業"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("インターネット広告代理事業"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("インターネットメディア事業"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("コンサルティング事業"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode("前号に付随する一切の事業 ")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("tr", null, [
      /*#__PURE__*/_createElementVNode("td", null, "資本金"),
      /*#__PURE__*/_createElementVNode("td", null, "2,008,000円")
    ])
  ])
], -1))

import LayoutComponent from "@/clinic/views/static/layout/index.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'CompanyProfile',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LayoutComponent, null, {
    title: _withCtx(() => [
      _createTextVNode("運営会社")
    ]),
    content: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})